var DetailGeneralController = (function () {
    function DetailGeneralController(topic, $scope, socket, $state, $stateParams) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.OPP_VERSION_3 = 3;
        this.socket.forward('queue.general', this.$scope);
        this.id = $stateParams.id;
        this.activeTab = $state.current.name;
        this.$scope.$on('socket:queue.general', function (event, data) {
            _this.loadData(event, data);
        });
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
    }
    DetailGeneralController.prototype.goTo = function (tab) {
        this.$state.go(tab.name, {
            id: this.id
        });
        this.activeTab = tab.name;
    };
    DetailGeneralController.prototype.loadData = function (ev, results) {
        this.tempData = results;
    };
    DetailGeneralController.prototype.edit = function () {
        console.log('detail.general.component:edit');
    };
    DetailGeneralController.$inject = ['topic', '$scope', 'socket', '$state', '$stateParams'];
    return DetailGeneralController;
}());
var DetailGeneralComponent = (function () {
    function DetailGeneralComponent() {
        this.templateUrl = 'detail-general.html';
        this.controllerAs = 'vm';
        this.controller = DetailGeneralController;
    }
    return DetailGeneralComponent;
}());
angular
    .module('application')
    .component('detailGeneral', new DetailGeneralComponent());

//# sourceMappingURL=detail.general.component.js.map
